// eslint-disable-next-line import/prefer-default-export
export var NEW_EMAIL_REQUIRED = 'NEW_EMAIL_REQUIRED';
export var EXCESSIVE_ATTEMPTS = 'EXCESSIVE_ATTEMPTS';
